Namespace 'Monitoring.Models.SocialContents.LinkedIn'

class Monitoring.Models.SocialContents.LinkedIn.LinkedInPost
  constructor: (linkedInPostBuilder) ->
    @text = linkedInPostBuilder.getText()
    @createdAt = linkedInPostBuilder.getCreatedAt()
    @contentId = linkedInPostBuilder.getContentId()
    @isBrandContent = linkedInPostBuilder.getIsBrandContent()
    @contentURN = linkedInPostBuilder.getContentURN()
    @hasMedia = linkedInPostBuilder.getHasMedia()

  getText: ->
    @text

  getCreatedAt: ->
    @createdAt

  getContentId: ->
    @contentId

  getIsBrandContent: ->
    @isBrandContent

  getContentURN: ->
    @contentURN

  getHasMedia: ->
    @hasMedia

  postURL: ->
    "https://www.linkedin.com/feed/update/#{@getContentURN()}"
